import DashboardIcon from '@mui/icons-material/Dashboard';
import GroupIcon from '@mui/icons-material/Group';
import CalculateIcon from '@mui/icons-material/Calculate';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import EmailIcon from '@mui/icons-material/Email';
import CloseIcon from '@mui/icons-material/Close';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const AdminMenu = ({ setShowApp, handleMenu, showApp }) => {
  const isActive = (key) => Boolean(showApp?.[key]);
  const handleAppRender = (appName) => {
    switch (appName) {
      case 'dashboard':
        return setShowApp({
          dashboard: true,
          projectsDashboard: false,
          pdfDashboard: false,
          disaster: false,
          users: false,
          findUser: false,
          calculations: false,
          roles: false,
          sendEmail: false,
        });
      case 'projectsDashboard':
        return setShowApp({
          dashboard: false,
          projectsDashboard: true,
          pdfDashboard: false,
          disaster: false,
          users: false,
          findUser: false,
          calculations: false,
          roles: false,
          sendEmail: false,
        });
      case 'pdfDashboard':
        return setShowApp({
          dashboard: false,
          projectsDashboard: false,
          pdfDashboard: true,
          disaster: false,
          users: false,
          findUser: false,
          calculations: false,
          roles: false,
          sendEmail: false,
        });
      case 'disaster':
        return setShowApp({
          dashboard: false,
          projectsDashboard: false,
          pdfDashboard: false,
          disaster: true,
          users: false,
          findUser: false,
          calculations: false,
          roles: false,
          sendEmail: false,
        });
      case 'users':
        return setShowApp({
          dashboard: false,
          projectsDashboard: false,
          pdfDashboard: false,
          disaster: false,
          users: true,
          findUser: false,
          calculations: false,
          roles: false,
          sendEmail: false,
        });
      case 'findUser':
        return setShowApp({
          dashboard: false,
          projectsDashboard: false,
          pdfDashboard: false,
          disaster: false,
          users: false,
          findUser: true,
          calculations: false,
          roles: false,
          sendEmail: false,
        });
      case 'calculations':
        return setShowApp({
          dashboard: false,
          projectsDashboard: false,
          pdfDashboard: false,
          disaster: false,
          users: false,
          findUser: false,
          calculations: true,
          roles: false,
          sendEmail: false,
        });
      case 'roles':
        return setShowApp({
          dashboard: false,
          projectsDashboard: false,
          pdfDashboard: false,
          disaster: false,
          users: false,
          findUser: false,
          calculations: false,
          roles: true,
          sendEmail: false,
        });
      case 'sendEmail':
        return setShowApp({
          dashboard: false,
          projectsDashboard: false,
          pdfDashboard: false,
          disaster: false,
          users: false,
          findUser: false,
          calculations: false,
          roles: false,
          sendEmail: true,
        });
      default:
        return setShowApp({
          dashboard: true,
          projectsDashboard: false,
          pdfDashboard: false,
          disaster: false,
          users: false,
          findUser: false,
          calculations: false,
          roles: false,
          sendEmail: false,
        });
    }
  };

  return (
    <div className="adminMenu">
      <div className="adminMenuCloseButton" onClick={handleMenu}>
        <CloseIcon color="primary" />
      </div>
      <div className={`listItem${isActive('dashboard') ? " active" : ""}`} onClick={() => handleAppRender('dashboard')}>
        <div className="icon">
          <DashboardIcon color="primary" />
        </div>
        <div className="text">User Dashboard</div>
      </div>
      <div className={`listItem${isActive('projectsDashboard') ? " active" : ""}`} onClick={() => handleAppRender('projectsDashboard')}>
        <div className="icon">
          <DashboardIcon color="primary" />
        </div>
        <div className="text">Projects Dashboard</div>
      </div>
      <div className={`listItem${isActive('pdfDashboard') ? " active" : ""}`} onClick={() => handleAppRender('pdfDashboard')}>
        <div className="icon">
          <DashboardIcon color="primary" />
        </div>
        <div className="text">PDF Dashboard</div>
      </div>
      <div className={`listItem${isActive('disaster') ? " active" : ""}`} onClick={() => handleAppRender('disaster')}>
        <div className="icon">
          <WarningAmberIcon color="primary" />
        </div>
        <div className="text">Disaster</div>
      </div>
      <div className={`listItem${isActive('users') ? " active" : ""}`} onClick={() => handleAppRender('users')}>
        <div className="icon">
          <GroupIcon color="primary" />
        </div>
        <div className="text">Filter Users</div>
      </div>
      <div className={`listItem${isActive('findUser') ? " active" : ""}`} onClick={() => handleAppRender('findUser')}>
        <div className="icon">
          <GroupIcon color="primary" />
        </div>
        <div className="text">FindUser</div>
      </div>
      <div className={`listItem${isActive('calculations') ? " active" : ""}`} onClick={() => handleAppRender('calculations')}>
        <div className="icon">
          <CalculateIcon color="primary" />
        </div>
        <div className="text">Calculations</div>
      </div>
      <div className={`listItem${isActive('roles') ? " active" : ""}`} onClick={() => handleAppRender('roles')}>
        <div className="icon">
          <ManageAccountsIcon color="primary" />
        </div>
        <div className="text">Roles</div>
      </div>
      <div className={`listItem${isActive('sendEmail') ? " active" : ""}`} onClick={() => handleAppRender('sendEmail')}>
        <div className="icon">
          <EmailIcon color="primary" />
        </div>
        <div className="text">Send Email</div>
      </div>
    </div>
  );
};

export default AdminMenu;
